'use client'

/**
 * Bookmarkable /settings → routes the signed-in user to their profile's Settings tab
 * (the real sectioned settings UI lives in /profile/[username]?tab=settings). Keeps a single
 * source of truth for the settings UI while giving users a clean, memorable URL.
 */
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export default function SettingsRedirect() {
  const { data: session, status } = useSession()
  const router = useRouter()

  useEffect(() => {
    if (status === 'loading') return
    if (!session?.user) {
      router.replace('/auth')
      return
    }
    const username = session.user.username || session.user.name
    router.replace(username ? `/profile/${username}?tab=settings` : '/auth')
  }, [session, status, router])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500 mx-auto mb-4" />
        <p className="text-white">Opening your settings…</p>
      </div>
    </div>
  )
}
